import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { FormikProps } from 'formik';
import { TypeRegister } from 'practice/constants/type-register';
import { Fragment, memo, useEffect, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FamilyVM } from '../family/table-family';
import AccordionPersonForm, { PersonFormVM } from './form';

interface AccordionPersonProps {
  disabled?: boolean;
  codeEnte?: string;
  yearId?: string;
  typeRegister?: string;
  progressive?: string;
  typePractice?: string;
  idFamily?: string;
  ForPracticeTemporary?: boolean;
  formContext: FormikProps<{
    family: Array<FamilyVM>;
    person?: PersonFormVM;
  }>;
  idAnprIntestatario?: boolean;
  isMaiAnagrafato?: boolean;
}

const AccordionPersonComponent = ({
  disabled,
  formContext,
  codeEnte,
  yearId,
  typeRegister,
  progressive,
  ForPracticeTemporary,
  typePractice,
  idFamily,
  idAnprIntestatario = false, // se true l'accordion è disabilitato
  isMaiAnagrafato = false,
}: AccordionPersonProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen((oldState) => {
      if (idAnprIntestatario) {
        return false;
      }

      if (!oldState) {
        return true;
      }

      return oldState;
    });
  }, [idAnprIntestatario]);

  const onFieldPersonChange = useEventCallback(
    (key: keyof PersonFormVM, value: PersonFormVM[keyof PersonFormVM]) => {
      formContext.setFieldValue('person', {
        ...(formContext.values.person || {}),
        [key]: value,
      });
    }
  );

  const onFieldsPersonChanges = useEventCallback((values: PersonFormVM) => {
    formContext.setFieldValue('person', {
      ...(formContext.values.person || {}),
      ...values,
    });
  });

  if (typeRegister === TypeRegister.Emigration) {
    return <></>;
  }

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          if (!idAnprIntestatario || ForPracticeTemporary) setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-person-content"
          id="panel-person-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Ci sono altre persone che si spostano?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <AccordionPersonForm
            ForPracticeTemporary={ForPracticeTemporary}
            disabled={disabled}
            values={formContext.values.person}
            onChange={onFieldPersonChange}
            codeEnte={codeEnte}
            yearId={yearId}
            typeRegister={typeRegister}
            progressive={progressive}
            typePractice={typePractice}
            idFamily={idFamily}
            onChangeFields={onFieldsPersonChanges}
            isMaiAnagrafato={isMaiAnagrafato}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionPersonComponent.displayName = 'Accordion person component';

const AccordionPerson = memo(AccordionPersonComponent);

export default AccordionPerson;
